function Map({ size = '17', color = '#959FAF', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      style={{ ...style }}
    >
      <path
        d="M3.81746 21.3207H0.956572V0.885742H21.3915V13.655H13.7268V21.3207H8.62228M0.956543 12.4038H9.50205V14.6331M21.3914 6.8306H16.9329"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Map;
